var map = {
	"./app-icon.svg": 398,
	"./arrow-left.svg": 399,
	"./arrow-right.svg": 400,
	"./check.svg": 401,
	"./chevron-down.svg": 402,
	"./chevron-left-left.svg": 403,
	"./chevron-left.svg": 404,
	"./chevron-right-right.svg": 405,
	"./chevron-right.svg": 406,
	"./chevron-up.svg": 407,
	"./cross.svg": 408,
	"./hamburger.svg": 409,
	"./help.svg": 410,
	"./power.svg": 411
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 397;


//////////////////
// WEBPACK FOOTER
// ./src/svg ^\.\/.*\.svg$
// module id = 397
// module chunks = 0